import FormForgotPassword from './FormForgotPassword-compose';

export default FormForgotPassword;
